@for (indicator of indicators(); track $index) {
  <div
    class="indicator d-flex gap-2 position-fixed align-items-center rounded-1 p-2 bottom-0 end-0 m-3"
    [class.removing]="indicator.removing"
  >
    <app-spinner small class="d-flex"></app-spinner>
    {{ indicator.title }}
  </div>
}
